// extracted by mini-css-extract-plugin
export default {"providerNoticeContainer":"providerNotice_providerNoticeContainer__G28PO","providerNoticeText":"providerNotice_providerNoticeText__pK+yf"};